import { registerPlugin } from '@capacitor/core';

export interface AppleOfferRedeemPlugin {
  presentRedeemSheet(): Promise<{ ok: boolean }>;
}

export const AppleOfferRedeem = registerPlugin<AppleOfferRedeemPlugin>('AppleOfferRedeem');
